<template>
    <v-flex xs6>
        <h1>Profile</h1>
        <CardLoader :max-height="400" v-if="loading"></CardLoader>
        <h2>Email: {{email}}</h2>
        <p>AWS Token: {{AWSToken}}</p>
    </v-flex>
</template>

<script>
    import axios from 'axios'
    import {store} from '../store/store'
    import CardLoader from "../components/CardLoader";

    export default {
        name: "Profile",
        data: () => ({
            loading: true,
            email: '',
            AWSToken: null
        }),
        components: {
            CardLoader
        },
        mounted() {
            axios.get('/authorize').then(resp => console.log(resp));
            this.AWSToken = store.state.AWSToken;
            this.email = store.state.email
        }
    }
</script>

<style scoped>

</style>
